import { render, staticRenderFns } from "./PanelHeading.vue?vue&type=template&id=0694c1f6&scoped=true&"
import script from "./PanelHeading.vue?vue&type=script&lang=js&"
export * from "./PanelHeading.vue?vue&type=script&lang=js&"
import style0 from "./PanelHeading.vue?vue&type=style&index=0&id=0694c1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0694c1f6",
  null
  
)

export default component.exports